/* eslint-disable */
// eslint-disable-next-line

var defaults = {
  title: "Default",
  description: "",
  items: [],
  attributes: [],
  audiences: "",
};

export default {
  data() {
    return {
      item: {
        title: "",
        description: "",
        items: [],
        options: [],
        audience: "",
        attributes: [],
      },
      editMode: false,
      editIndex: null,
      deleteMode: false,
      newMode: true,
      deleteId: null,
      dialog: false,
    };
  },
  methods: {
    add() {
      this.item = defaults;
      this.editMode = false;
      this.newMode = true;
      this.dialog = true;
      console.log("Add");
      this.resetItem();
    },
    addItem() {
      let item = {
        index: this.items.length,
        title: this.populateField(this.item.title),
        description: this.populateField(this.item.description),
        items: this.populateArray(this.item.items),
        options: this.populateArray(this.item.options),
        attributes: this.populateArray(this.item.attributes),
        audience: this.item.audience,
        // id: this.items.length,
        id: new Date().valueOf(),
        type: "content",
      };
      this.items.push(item);

      this.editMode = false;
      this.currId = null;
      this.currIndex = null;
      this.dialog = false;
      this.newMode = false;
      this.resetItem();
      this.$emit("handleEnd");
    },
    remove(id) {
      console.log("remove", id);
      this.deleteMode = true;
      this.newMode = false;
      this.deleteId = id;
      this.dialog = true;
    },
    removeItem() {
      this.item = this.items.find((x) => x.id === this.deleteId);
      const indexOfItem = this.items.indexOf(this.item);
      console.log("found item", this.item, indexOfItem);
      this.items.splice(indexOfItem, 1);
      this.cancel();
      this.$emit("handleEnd");
    },
    edit(id) {
      console.log("edit", id);
      this.editMode = true;
      this.newMode = false;
      this.dialog = true;
      this.editIndex = id;
      // this.item = this.items[this.editIndex];
      this.item = this.items.find((x) => x.id === this.editIndex);
    },
    editItem() {
      let item = {
        ...this.item,
        id: new Date().valueOf(),
        title: this.populateField(this.item.title),
        description: this.populateField(this.item.description),
        items: this.populateArray(this.item.items),
        options: this.populateArray(this.item.options),
        attributes: this.populateArray(this.item.attributes),
        audience: this.populateField(this.item.audience),
      };
      const indexOfItem = this.items.indexOf(this.item);
      this.$set(this.items, indexOfItem, item);
      this.editMode = false;
      this.currId = null;
      this.currIndex = null;
      this.newMode = false;
      this.dialog = false;
      this.resetItem();
      this.$emit("handleEnd");
    },
    cancel() {
      this.dialog = false;
      this.deleteId = null;
      this.deleteMode = false;
      this.newMode = false;
    },
    populateField(field) {
      return field ? field : "";
    },
    populateArray(field) {
      return field && field.length ? field : [];
    },
    resetItem() {
      this.item = {};
      this.$set(this.item, "items", []);
    },
    checkEditIndex(index) {
      if (this.editMode) {
        return index == this.editIndex ? false : true;
      } else {
        return false;
      }
    },
  },
};
